<template>
  <div
    class="
      cruise-itinerary-card
      tw-flex tw-flex-col
      sm:tw-flex-row
      tw-mb-12
      sm:tw-mb-2.5
    "
  >
    <div class="tw-flex-shrink-0 sm:tw-w-1/2">
      <img class="tw-w-full" :src="computedImage" :alt="cardData.Name" />
    </div>
    <div class="tw-px-2.5 tw-pb-4 tw-pt-2 sm:tw-pt-0 sm:tw-pb-0 tw-w-full">
      <div
        class="
          tw-flex
          tw-items-center
          tw-pb-0.5
          tw-mb-0.5
          tw-border-b
          tw-border-black
          tw-border-solid
        "
      >
        <div class="tw-font-semibold tw-text-xs sm:tw-mr-7 tw-mr-12">
          {{ textLabels.cruiseItineraryMapDayLabel }} {{ currentDay }}
        </div>
        <div v-if="!cardData.IsSeaDay">
          <div class="tw-font-semibold tw-text-xs">
            {{ cardData.Name }}
          </div>
          <div
            class="tw-text-xs"
            v-if="this.arrivalTimeExists || this.departureTimeExists"
          >
            {{ computedTime }}
          </div>
        </div>
        <div v-else class="tw-font-semibold tw-text-xs">
          {{ cardData.Name }}
        </div>
      </div>
      <div v-html="cardData.Summary" class="tw-text-sm"></div>
    </div>
  </div>
</template>

<script>
import TimeConverter from "@/mixins/TimeConverter";
import TimeMixin from "@/stories/Components/CruiseItineraryDetail/Mixins/TimeMixin.js";

export default {
  name: "ItineraryCard",
  mixins: [TimeConverter, TimeMixin],
  props: {
    cardData: {
      type: Object,
      required: true,
    },
    textLabels: {
      type: Object,
      required: true,
      default: () => {},
    },
    currentDay: {
      type: Number,
      required: true,
      default: 0,
    },
    arrivalTime: {
      type: String,
      required: true,
      default: "",
    },
    departureTime: {
      type: String,
      required: true,
      default: "",
    },
    isDesktopSm: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  computed: {
    computedImage() {
      return this.isDesktopSm
        ? this.cardData.Images?.Desktop
        : this.cardData.Images?.Mobile ||
            require("@/assets/images/sea-day-placeholder-mobile.jpg");
    },
    computedTime() {
      let space = "";
      if (this.arrivalTimeExists && this.departureTimeExists) {
        space = " ";
      }
      return `${this.arrivalData}${space}${this.departureData}`;
    },
    arrivalTimeExists() {
      return this.isValidTime(this.arrivalTime);
    },
    arrivalData() {
      const { cruiseCardPriceFromLabel } = this.textLabels;

      return this.arrivalTimeExists
        ? `${cruiseCardPriceFromLabel} ${this.getNonMilitaryTime(
            this.arrivalTime,
            true
          )}`
        : "";
    },
    departureTimeExists() {
      return this.isValidTime(this.departureTime);
    },
    departureData() {
      const { cruiseItineraryToLabel } = this.textLabels;
      return this.departureTimeExists
        ? `${cruiseItineraryToLabel} ${this.getNonMilitaryTime(
            this.departureTime,
            true
          )}`
        : "";
    },
  },
};
</script>
